import { ProcessField } from './process-field';
import { Approval } from './approval';
import { ProcessStatus } from '../types/process-status';
import { ActionType } from '../types/action-type';
import { OrgUnitType } from '../types/org-unit-type';
import { ProcessAttachment } from './process-attachment';

export class Process {
  id: string | undefined;
  formId: string | undefined;
  formName: string | undefined;
  timestamp: string | undefined;
  number: number | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  username: string | undefined;
  emailAddress: string | undefined;
  uidNumber: string | undefined;
  status: ProcessStatus | undefined;
  fields: ProcessField[] | undefined;
  approvals: Approval[] | undefined;
  operator: boolean | undefined;
  reader: boolean | undefined;
  actionType: ActionType | undefined;
  inProgress: Date | undefined;
  finished: Date | undefined;
  lastOperator: string | undefined;
  preProgressComment: string | undefined;
  progressComment: string | undefined;
  resubmitted: string | undefined;
  transmitted: Date | undefined;
  canceled: string | undefined;
  attachments: ProcessAttachment[] | undefined;
  changedByOther: string | undefined;
  latestFormId: string | undefined;
  test: boolean | undefined;
  formAllowCancelUntilProgressStarts: boolean | undefined;
  formTimestamp: string | undefined;
  formOrgUnitType: OrgUnitType | undefined;
  formContactEmail: string | undefined;
  formContactTelephone: string | undefined;
  formOrgUnitName: string | undefined;
  formPrivacyReason: string | undefined;
  formDataFields: string | undefined;
  formLegalBasis: string | undefined;
  formDataTransmission: string | undefined;
  formExternalDataTransmission: string | undefined;
  formStoragePeriod: number | undefined;
}
